var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalDiscoverability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 69.4531V313.086C2.73438 324.844 12.0312 334.141 23.7891 334.141H326.211C337.695 334.141 347.266 324.57 347.266 313.086V69.4531H2.73438Z",
    fill: "#A6E1FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6172 173.633H208.086V309.805H27.6172V173.633Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.305 173.906H208.086V310.078H187.305V173.906Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M322.383 106.094V140.547C322.383 145.195 318.555 149.023 313.906 149.023H36.0937C31.4453 149.023 27.6172 145.195 27.6172 140.547V106.094C27.6172 101.445 31.4453 97.6172 36.0937 97.6172H313.906C318.555 97.6172 322.383 101.445 322.383 106.094Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3047 97.6172H36.0937C31.4453 97.6172 27.6172 101.445 27.6172 106.094V140.547C27.6172 145.195 31.4453 149.023 36.0937 149.023H82.3047V97.6172Z",
    fill: "#7BDE9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9609 148.75H36.0937C31.4453 148.75 27.6172 144.922 27.6172 140.273V106.094C27.6172 101.445 31.4453 97.6172 36.0937 97.6172H54.9609C50.3125 97.6172 46.4844 101.445 46.4844 106.094V140.547C46.4844 144.922 50.3125 148.75 54.9609 148.75Z",
    fill: "#A7E9BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M322.383 106.094V140.547C322.383 145.195 318.555 149.023 313.906 149.023H295.039C299.688 149.023 303.516 145.195 303.516 140.547V106.094C303.516 101.445 299.688 97.6172 295.039 97.6172H313.906C318.555 97.6172 322.383 101.445 322.383 106.094Z",
    fill: "#EDEDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M347.266 69.4531V313.086C347.266 324.844 337.969 334.141 326.211 334.141H306.523C318.281 334.141 327.578 324.57 327.578 313.086V69.4531H347.266Z",
    fill: "#7AD1F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 69.4531V313.086C2.73438 324.844 12.0312 334.141 23.7891 334.141H43.4766C31.7187 334.141 22.4219 324.57 22.4219 313.086V69.4531H2.73438Z",
    fill: "#D3F0FD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M347.266 69.4531V36.6406C347.266 24.8828 337.695 15.5859 326.211 15.5859H23.7891C12.3047 15.5859 2.73438 25.1562 2.73438 36.6406V69.4531H347.266Z",
    fill: "#D3D9D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4766 15.5859C31.7187 15.5859 22.4219 24.8828 22.4219 36.6406V69.4531H2.73438V36.6406C2.73438 24.8828 12.0312 15.5859 23.7891 15.5859H43.4766Z",
    fill: "#EDEDED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.266 36.6406V69.4531H327.578V36.6406C327.578 24.8828 318.008 15.5859 306.523 15.5859H326.211C337.969 15.5859 347.266 25.1562 347.266 36.6406Z",
    fill: "#A8B2B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7266 52.2266C40.0121 52.2266 44.2969 47.9418 44.2969 42.6562C44.2969 37.3707 40.0121 33.0859 34.7266 33.0859C29.441 33.0859 25.1562 37.3707 25.1562 42.6562C25.1562 47.9418 29.441 52.2266 34.7266 52.2266Z",
    fill: "#F58120"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6328 52.2266C73.9184 52.2266 78.2031 47.9418 78.2031 42.6562C78.2031 37.3707 73.9184 33.0859 68.6328 33.0859C63.3473 33.0859 59.0625 37.3707 59.0625 42.6562C59.0625 47.9418 63.3473 52.2266 68.6328 52.2266Z",
    fill: "#FEDD8E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.812 52.2266C108.098 52.2266 112.383 47.9418 112.383 42.6562C112.383 37.3707 108.098 33.0859 102.812 33.0859C97.527 33.0859 93.2422 37.3707 93.2422 42.6562C93.2422 47.9418 97.527 52.2266 102.812 52.2266Z",
    fill: "#7BDE9E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0234 42.6563C44.0234 47.8516 39.6484 52.2266 34.4531 52.2266C30.3516 52.2266 26.7969 49.4922 25.4297 45.9375C26.5234 46.2109 27.6172 46.4844 28.7109 46.4844C33.9062 46.4844 38.2812 42.1094 38.2812 36.9141C38.2812 35.8203 38.0078 34.7266 37.7344 33.6328C41.5625 35 44.0234 38.5547 44.0234 42.6563Z",
    fill: "#F58120"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2031 42.6563C78.2031 47.8516 73.8281 52.2266 68.6328 52.2266C64.5313 52.2266 60.9766 49.4922 59.6094 45.9375C60.7031 46.2109 61.7969 46.4844 62.8906 46.4844C68.0859 46.4844 72.4609 42.1094 72.4609 36.9141C72.4609 35.8203 72.1875 34.7266 71.9141 33.6328C75.4687 35 78.2031 38.5547 78.2031 42.6563Z",
    fill: "#FDD267"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.383 42.6563C112.383 47.8516 108.008 52.2266 102.812 52.2266C98.7109 52.2266 95.1562 49.4922 93.7891 45.9375C94.8828 46.2109 95.9766 46.4844 97.0703 46.4844C102.266 46.4844 106.641 42.1094 106.641 36.9141C106.641 35.8203 106.367 34.7266 106.094 33.6328C109.648 35 112.383 38.5547 112.383 42.6563Z",
    fill: "#50D27E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M324.844 42.6562C324.844 47.8516 320.469 52.2266 315.273 52.2266H156.953C151.758 52.2266 147.383 47.8516 147.383 42.6562C147.383 37.4609 151.758 33.0859 156.953 33.0859H315.273C320.742 33.0859 324.844 37.1875 324.844 42.6562Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324.844 42.6562C324.844 47.8516 320.469 52.2266 315.273 52.2266H156.953C151.758 52.2266 147.656 48.125 147.383 43.2031C148.75 44.0234 150.391 44.2969 152.031 44.2969H310.352C315.547 44.2969 319.922 39.9219 319.922 34.7266V34.4531C322.93 35.8203 324.844 38.8281 324.844 42.6562Z",
    fill: "#EDEDED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8828 114.023C63.7109 117.852 63.7109 124.141 59.8828 128.242C56.0547 132.07 49.7656 132.07 45.6641 128.242C41.8359 124.414 41.8359 118.125 45.6641 114.023C49.7656 110.195 56.0547 110.195 59.8828 114.023Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M187.305 278.086L176.641 289.297L150.938 264.414L141.094 284.922L123.867 227.773L181.563 242.812L161.602 253.477L187.305 278.086Z",
    fill: "#F58120"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.305 278.086L176.641 289.297L167.344 280.273L178.008 269.062L187.305 278.086Z",
    fill: "#F58120"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.086 247.461L132.891 236.797L144.922 276.992L141.094 284.922L123.867 227.773L181.563 242.812L173.086 247.461Z",
    fill: "#F58120"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.969 173.633H322.109V229.414H232.969V173.633Z",
    fill: "#FEDD8E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M301.602 173.633H322.383V229.414H301.602V173.633Z",
    fill: "#FDD367"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M232.969 173.633H253.75V229.414H232.969V173.633Z",
    fill: "#FEE9B4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M232.969 254.297H322.109V310.078H232.969V254.297Z",
    fill: "#FEDD8E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M301.602 254.297H322.383V310.078H301.602V254.297Z",
    fill: "#FDD367"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M232.969 254.297H253.75V310.078H232.969V254.297Z",
    fill: "#FEE9B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalDiscoverability);
export default __webpack_public_path__ + "static/media/ExternalDiscoverability.3d3eabf790ca1c695f03d8d99171c21a.svg";
export { ForwardRef as ReactComponent };